import EmptyState from '@atlaskit/empty-state/empty-state';
import { FormattedMessage } from 'react-intl';

import { FlagIllustrationLight } from './illustration-flag';
import { type JSX } from 'react/jsx-runtime';

export const NoNotificationsMessage: JSX.Element = (
	<FormattedMessage
		id="no-notifications-fallback.no-notifications.text"
		description="Message explaining to the user that there has not been messages in X period of time"
		defaultMessage="Check back soon. No notifications yet."
	/>
);

export const NoNotificationsFallback = (): JSX.Element => (
	<EmptyState
		header={' '}
		description={
			<>
				<p>
					<FormattedMessage
						id="no-notifications-fallback.no-notifications.text"
						description="Message explaining to the user that there has not been messages in X period of time"
						defaultMessage="Check back soon. No notifications yet."
					/>
				</p>
				<p>
					<a
						href="https://community.atlassian.com/t5/Atlassian-Platform-articles/Admin-hub-notifications-are-now-in-beta/ba-p/2590735"
						target="_blank"
						rel="noopener noreferrer"
					>
						<FormattedMessage
							id="no-notifications-fallback.learn-more-link.text"
							description="Message explaining to the user that there has not been messages in X period of time"
							defaultMessage="Learn more about this feature"
						/>
					</a>
				</p>
			</>
		}
		headingLevel={2}
		renderImage={FlagIllustrationLight}
	/>
);
